// extracted by mini-css-extract-plugin
module.exports = {"breadCrumbs":"SearchBooksetsView__breadCrumbs","bookset":"SearchBooksetsView__bookset"};